import { render, staticRenderFns } from "./SubscribeOrderDelivered.vue?vue&type=template&id=063287e1"
import script from "./SubscribeOrderDelivered.vue?vue&type=script&lang=js"
export * from "./SubscribeOrderDelivered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports